import { Table } from 'semantic-ui-react';
import { testCentreOverviewStore } from 'store';
import { TestCentreOverviewQueryFilters } from 'store/test-centre-overview/service';
import {
  COLUMN_ORDER,
  getLrwPairingCellContent,
  getSpeakingSessionCellContent,
  isRowSpannedColumn,
} from './table-columns';
import { LoadingRow } from './LoadingRow';

export const TestCentreOverviewSessionRows = ({
  centreId,
  date,
  districtId,
  filters,
}: {
  centreId: number | undefined;
  date: string;
  districtId: number;
  filters: TestCentreOverviewQueryFilters;
}) => {
  const { data: sessions, isFetching } =
    testCentreOverviewStore.service.useGetTestCentreOverviewSessionsForDistrictQuery(
      { centreId, date, districtId, filters },
      { skip: !centreId }
    );

  if (isFetching) {
    return <LoadingRow colSpan={COLUMN_ORDER.length} label="Loading..." />;
  }

  return (
    <>
      {(sessions ?? []).flatMap((session, sessionIndex) =>
        session.lrwPairings.map((pairing, pairingIndex) => (
          <Table.Row key={`${sessionIndex}-${pairingIndex}`}>
            {COLUMN_ORDER.map((key) => {
              if (isRowSpannedColumn(key)) {
                if (pairingIndex !== 0) {
                  return null;
                }

                return (
                  <Table.Cell key={key} rowSpan={session.lrwPairings.length}>
                    {getSpeakingSessionCellContent(key, session.speakingSession)}
                  </Table.Cell>
                );
              }

              return (
                <Table.Cell
                  key={key}
                  style={{
                    borderLeft: '1px solid rgba(34,36,38,.1)',
                    whiteSpace: key === 'lrwSessionTime' ? 'nowrap' : undefined,
                  }}
                >
                  {getLrwPairingCellContent(key, pairing)}
                </Table.Cell>
              );
            })}
          </Table.Row>
        ))
      )}
    </>
  );
};
